package com.gsb.vyapar.bhagya.presentation.dialog.view

import com.gsb.vyapar.bhagya.presentation.dialog.uistate.DialogUiState
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.wrapContentHeight
import androidx.compose.foundation.layout.wrapContentWidth
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.CircularProgressIndicator
import androidx.compose.material.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight.Companion.SemiBold
import androidx.compose.ui.text.style.TextAlign.Companion.Center
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import androidx.compose.ui.window.Dialog
import androidx.compose.ui.window.DialogProperties
import com.gsb.vyapar.bhagya.interactor.util.hideError
import com.gsb.vyapar.bhagya.interactor.util.hideSuccess
import com.gsb.vyapar.bhagya.presentation.common.button.GVBButton
import com.gsb.vyapar.bhagya.presentation.common.button.GVBButtonDialog
import com.gsb.vyapar.bhagya.presentation.common.button.GVBButtonReport
import com.gsb.vyapar.bhagya.presentation.common.image.PlaceHolder
import com.gsb.vyapar.bhagya.presentation.dialog.Dialogs
import com.gsb.vyapar.bhagya.presentation.dialog.Dialogs.Loading
import com.gsb.vyapar.bhagya.presentation.location.uistate.getLocationUiState
import com.gsb.vyapar.bhagya.presentation.location.util.savePincode
import com.gsb.vyapar.bhagya.presentation.location.util.hidePincodeDialog
import com.gsb.vyapar.bhagya.presentation.common.edittext.PincodeEditText
import com.gsb.vyapar.bhagya.presentation.common.image.CommonImage
import com.gsb.vyapar.bhagya.presentation.common.text.Text24SemiBold
import com.gsb.vyapar.bhagya.theme.background
import com.gsb.vyapar.bhagya.theme.black
import com.gsb.vyapar.bhagya.theme.close_black
import com.gsb.vyapar.bhagya.theme.failure
import com.gsb.vyapar.bhagya.theme.interRegular
import com.gsb.vyapar.bhagya.theme.interSemiBold
import com.gsb.vyapar.bhagya.theme.primary
import com.gsb.vyapar.bhagya.theme.splash
import com.gsb.vyapar.bhagya.theme.sucess

@Composable
fun DialogView(dialogUiState: DialogUiState) {
    Dialog(
        onDismissRequest = { },
        properties = DialogProperties(
            dismissOnBackPress = false,
            dismissOnClickOutside = false,
            usePlatformDefaultWidth = false
        )
    ) {
        when (dialogUiState.dialogType) {
            Loading -> {
                Column(
                    modifier = Modifier.width(260.dp).wrapContentHeight()
                        .background(background, shape = RoundedCornerShape(20.dp))
                        .padding(all = 22.dp), horizontalAlignment = Alignment.CenterHorizontally
                ) {
                    CircularProgressIndicator(color = primary)
                    Spacer(modifier = Modifier.height(20.dp))
                    Text(
                        text = "Loading...",
                        color = primary,
                        fontFamily = interRegular(),
                        fontSize = 18.sp,
                        modifier = Modifier.padding(bottom = 20.dp).padding(horizontal = 16.dp),
                        textAlign = Center,
                        fontWeight = SemiBold
                    )
                }
            }

            Dialogs.Error -> {
                Column(
                    modifier = Modifier.verticalScroll(rememberScrollState()).width(260.dp).wrapContentHeight()
                        .background(background, shape = RoundedCornerShape(20.dp))
                        .padding(all = 22.dp), horizontalAlignment = Alignment.CenterHorizontally
                ) {
                    PlaceHolder(failure, 50.dp, 50.dp)
                    Spacer(modifier = Modifier.height(20.dp))
                    Text(
                        text = dialogUiState.message,
                        color = black,
                        fontFamily = interRegular(),
                        fontSize = 18.sp,
                        modifier = Modifier.padding(bottom = 20.dp).padding(horizontal = 16.dp),
                        textAlign = Center,
                        fontWeight = SemiBold
                    )
                    Spacer(Modifier.height(8.dp))
                    GVBButton(text = "OK", onClick = { hideError() })
                }
            }

            Dialogs.Success -> {
                Column(
                    modifier = Modifier.width(260.dp).wrapContentHeight()
                        .background(background, shape = RoundedCornerShape(20.dp))
                        .padding(all = 22.dp), horizontalAlignment = Alignment.CenterHorizontally
                ) {
                    PlaceHolder(sucess, 50.dp, 50.dp)
                    Spacer(modifier = Modifier.height(20.dp))
                    Text(
                        text = dialogUiState.message,
                        color = black,
                        fontFamily = interRegular(),
                        fontSize = 18.sp,
                        modifier = Modifier.padding(bottom = 20.dp).padding(horizontal = 16.dp),
                        textAlign = Center,
                        fontWeight = SemiBold
                    )
                    Spacer(Modifier.height(8.dp))
                    GVBButton(text = "OK", onClick = { hideSuccess() })
                }
            }

            Dialogs.Regular -> {
                Column(
                    modifier = Modifier.width(280.dp).wrapContentHeight()
                        .background(background, shape = RoundedCornerShape(20.dp))
                        .padding(all = 22.dp), horizontalAlignment = Alignment.CenterHorizontally
                ) {
                    Text(
                        text = dialogUiState.message,
                        color = black,
                        fontFamily = interRegular(),
                        fontSize = 18.sp,
                        modifier = Modifier.padding(bottom = 20.dp).padding(horizontal = 16.dp),
                        textAlign = Center,
                        fontWeight = SemiBold
                    )
                    Spacer(Modifier.height(8.dp))
                    Row() {
                        GVBButtonDialog(text = "Cancel", onClick = { dialogUiState.onCancelClick() })
                        Spacer(Modifier.width(8.dp))
                        GVBButtonDialog(text = "OK", onClick = { dialogUiState.onOKClick() })
                    }
                }
            }

            Dialogs.Login -> {
                Column(
                    modifier = Modifier.width(280.dp).wrapContentHeight()
                        .background(background, shape = RoundedCornerShape(20.dp))
                        .padding(all = 22.dp), horizontalAlignment = Alignment.CenterHorizontally
                ) {
                    Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.End) {
                        CommonImage(close_black, 20.dp, 20.dp, Modifier.clickable{ dialogUiState.onCloseClick()})
                    }
                    Text(
                        text = dialogUiState.message,
                        color = black,
                        fontFamily = interSemiBold(),
                        fontSize = 18.sp,
                        modifier = Modifier.padding(bottom = 20.dp).padding(horizontal = 16.dp),
                        textAlign = Center,
                        fontWeight = SemiBold
                    )
                    Spacer(Modifier.height(8.dp))
                    GVBButtonReport(text = dialogUiState.otpLogin, onClick = { dialogUiState.onOtpLoginClick() })
                    Spacer(Modifier.height(8.dp))
                    GVBButtonReport(text = dialogUiState.passwordLogin, onClick = { dialogUiState.onPasswordLoginClick() })
                }
            }

            Dialogs.Message -> {
                Column(
                    modifier = Modifier.width(260.dp).wrapContentHeight()
                        .background(background, shape = RoundedCornerShape(20.dp))
                        .padding(all = 22.dp), horizontalAlignment = Alignment.CenterHorizontally
                ) {
                    PlaceHolder(splash, 50.dp, 50.dp)
                    Spacer(modifier = Modifier.height(20.dp))
                    Text(
                        text = dialogUiState.message,
                        color = black,
                        fontFamily = interRegular(),
                        fontSize = 18.sp,
                        modifier = Modifier.padding(bottom = 20.dp).padding(horizontal = 16.dp),
                        textAlign = Center,
                        fontWeight = SemiBold
                    )
                    Spacer(Modifier.height(8.dp))
                    GVBButton(text = dialogUiState.buttonString, onClick = { dialogUiState.onOKClick() })
                }
            }
            Dialogs.Image -> {
                Column(
                    modifier = Modifier.width(280.dp).wrapContentHeight()
                        .background(background, shape = RoundedCornerShape(20.dp))
                        .padding(all = 22.dp), horizontalAlignment = Alignment.CenterHorizontally
                ) {
                    Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.End) {
                        CommonImage(close_black, 20.dp, 20.dp, Modifier.clickable{ dialogUiState.onCloseClick()})
                    }
                    Text(
                        text = dialogUiState.message,
                        color = black,
                        fontFamily = interSemiBold(),
                        fontSize = 18.sp,
                        modifier = Modifier.padding(bottom = 20.dp).padding(horizontal = 16.dp),
                        textAlign = Center,
                        fontWeight = SemiBold
                    )
                    Spacer(Modifier.height(8.dp))
                    GVBButton(text = dialogUiState.camera, onClick = { dialogUiState.onCameraClick() })
                    Spacer(Modifier.height(8.dp))
                    GVBButton(text = dialogUiState.gallery, onClick = { dialogUiState.onGalleryClick() })
                }
            }

            Dialogs.Pincode -> {
                var pincode by remember { mutableStateOf(getLocationUiState().pincode) }
                Column(
                    modifier = Modifier.width(280.dp).wrapContentHeight()
                        .background(background, shape = RoundedCornerShape(20.dp))
                        .padding(all = 22.dp), horizontalAlignment = Alignment.CenterHorizontally
                ) {
                    Text24SemiBold(
                        text = dialogUiState.title.ifEmpty { "Enter your pincode to discover nearby businesses" },
                        color = black
                    )
                    Spacer(Modifier.height(16.dp))
                    PincodeEditText(pincode, true) { pincode = it }
                    Spacer(Modifier.height(16.dp))
                    GVBButton(text = "Save") {
                        dialogUiState.onSavePincode(pincode)
                    }
                }
            }

            Dialogs.AddBusinessPincode -> {
                var pincode by remember { mutableStateOf("") }
                Column(
                    modifier = Modifier.width(280.dp).wrapContentHeight()
                        .background(background, shape = RoundedCornerShape(20.dp))
                        .padding(all = 22.dp), horizontalAlignment = Alignment.CenterHorizontally
                ) {
                    Text24SemiBold(
                        text = dialogUiState.title.ifEmpty { "Enter your pincode to discover nearby businesses" },
                        color = black
                    )
                    Spacer(Modifier.height(16.dp))
                    PincodeEditText(pincode, true) { pincode = it }
                    Spacer(Modifier.height(16.dp))
                    GVBButton(text = "Save") {
                        dialogUiState.onSavePincode(pincode)
                    }
                }
            }

            Dialogs.Location -> {
                Column(
                    modifier = Modifier.width(280.dp).wrapContentHeight()
                        .background(background, shape = RoundedCornerShape(20.dp))
                        .padding(all = 22.dp), horizontalAlignment = Alignment.CenterHorizontally
                ) {
                    Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.End) {
                        CommonImage(close_black, 20.dp, 20.dp, Modifier.clickable{ dialogUiState.onCloseClick()})
                    }
                    Text24SemiBold(
                        text = dialogUiState.title.ifEmpty { "Update Your Location" },
                        color = black
                    )
                    Spacer(Modifier.height(16.dp))
                    Text(
                        text = dialogUiState.message.ifEmpty { "To provide the best experience, we need your current location.\n" + "You can choose one of the following options:" },
                        color = black,
                        fontFamily = interSemiBold(),
                        fontSize = 18.sp,
                        modifier = Modifier.padding(bottom = 20.dp).padding(horizontal = 16.dp),
                        textAlign = Center,
                        fontWeight = SemiBold
                    )
                    Spacer(Modifier.height(8.dp))
                    GVBButtonReport(text = dialogUiState.deviceLocation, onClick = { dialogUiState.onDeviceLocationClick() })
                    Spacer(Modifier.height(8.dp))
                    GVBButtonReport(text = dialogUiState.enterPincode, onClick = { dialogUiState.onEnterPincodeClick() })
                }
            }
        }
    }
}